import { render, staticRenderFns } from "./OffersNotFound.vue?vue&type=template&id=2fb4c505&scoped=true&"
import script from "./OffersNotFound.vue?vue&type=script&lang=js&"
export * from "./OffersNotFound.vue?vue&type=script&lang=js&"
import style0 from "./OffersNotFound.vue?vue&type=style&index=0&id=2fb4c505&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb4c505",
  null
  
)

export default component.exports